
// Get all anchor links within .js-dropdown-show-extra
const links = document.querySelectorAll('.js-dropdown-show-extra a');
const dropdownContainers = document.querySelectorAll('.js-dropdown-show-extra');

links.forEach(link => {
    link.addEventListener('mouseover', () => {
        
        const target = link.getAttribute('data-target');
        const dropdownBlocks = link.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.nav-dropdown-extra-block');
        let targetMet = false;
        dropdownBlocks.forEach(block => {
            if (block.id === target) {
                block.classList.add('is-active');
                targetMet = true;
            } else {
                block.classList.remove('is-active');
            }
        });
        if (!targetMet) {
            dropdownBlocks[0].classList.add('is-active');
        }
    });
});


dropdownContainers.forEach(dropdownContainer => {
    const dropdownParentContainer = dropdownContainer.parentNode.parentNode;
    dropdownParentContainer.addEventListener('mouseleave', () => {
        const dropdownBlocks = dropdownContainer.parentNode.parentNode.querySelectorAll('.nav-dropdown-extra-block');
        dropdownBlocks.forEach(block => {
            block.classList.remove('is-active');
        });
        dropdownBlocks[0].classList.add('is-active');
    });
});